// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"preliminary-panel__container___2WFv4","heading":"preliminary-panel__heading___31YeV","item-container":"preliminary-panel__item-container___2xtf1","itemContainer":"preliminary-panel__item-container___2xtf1","item":"preliminary-panel__item___1obaS"};
    if(module.hot) {
      // 1772070403365
      var cssReload = require("../../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  